// extracted by mini-css-extract-plugin
module.exports = {"cart":"_6197","icon":"_13562","counter":"_3852","style2":"_7256"};